export abstract class TypEnum {
    static Adres:string = 'Adres';
    static Header:string = 'Header';
    static ModuleHeader:string = 'ModuleHeader';
    static Position:string = 'Position';
    static ModuleFooter:string = 'ModuleFooter';
    static Footer:string = 'Footer';
  }
  